import { ref, type Ref } from 'vue';
import { FinancialInstitution } from '@/modules/predefined/models/FinancialInstitution';

export const connectedFinancialInstitutions: Ref<FinancialInstitution[]> = ref([]);
export const connectedFinancialInstitutionPromise: Ref<Promise<FinancialInstitution[]> | null> =
  ref(null);
